import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Injectable()
export class HelpersService {
  public hasBanner: Subject<boolean> = new Subject();

  constructor() {
    const userAgent = isPlatformBrowser(PLATFORM_ID) && navigator.userAgent ? navigator.userAgent : '';
    this.device = {
      ...this.device,
      width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      isTouch: 'ontouchstart' in window,
      isIos: userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i) ? true : false,
      isAndroid: userAgent.match(/Android/i) ? true : false
    };
  }

  device = {
    width: 1000,
    xlarge: 1440,
    large: 1024,
    medium: 768,
    small: 375,
    isTouch: false,
    isIos: false,
    isAndroid: false,

    isTouchDevice: function() {
      return this.isTouch;
    },

    isIosDevice: function() {
      return this.isIos;
    },

    isAndroidDevice: function() {
      return this.isAndroid;
    },

    isXsOnly: function() {
      return this.width < this.small;
    },

    isSmUp: function() {
      return this.width >= this.small;
    },

    isSmOnly: function() {
      return this.width >= this.small && this.width < this.medium;
    },

    isMdUp: function() {
      return this.width >= this.medium;
    },

    isMdOnly: function() {
      return this.width >= this.medium && this.width < this.large;
    },

    isLgUp: function() {
      return this.width >= this.large;
    },

    isLgOnly: function() {
      return this.width >= this.large && this.width <= this.xlarge;
    },

    isXlUp: function() {
      return this.width > this.xlarge;
    },

    getWidth: function() {
      return this.width;
    }
  };

  scroll(targetEl) {
    targetEl.scrollIntoView();
  }

  smoothScrollTo(x: number, y: number) {
    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    if (isSmoothScrollSupported) {
      // Native smooth scrolling
      window.scrollTo({
        behavior: 'smooth',
        left: x,
        top: y
      });
    } else {
      // Old way scrolling without effects
      window.scrollTo(x, y);
    }
  }

  toggleAccordionOpenClass(event) {
    if (event.isOpen) {
      return event.index;
    } else {
      return 0;
    }
  }

  checkInput(event, component): void {
    if (component['level'] === event.target) {
      event.target.checked = false;
      component['level'] = null;
    } else {
      component['level'] = event.target;
    }
  }
}
